'use client';
/* eslint-disable tailwindcss/no-arbitrary-value */

import { AsideModal } from '@hyphengroup/cms-components/components/AsideModal';
import ProductGridCard from '@hyphengroup/cms-components/components/ProductGridCard';
import type { RewardCardGridDetailsModalItem } from '../types';

type RewardCardGridDetailsModalProps = {
  item: RewardCardGridDetailsModalItem | null;
  onClose: () => void;
};

export const RewardCardGridDetailsModal = ({
  item,
  onClose,
}: RewardCardGridDetailsModalProps) => {
  if (!item) {
    return null;
  }

  const giftTitle = item.gift?.gift_title ?? '';
  const imageUrl = item.gift?.desktop_image || item.gift?.mobile_image;

  return (
    <AsideModal isOpen={Boolean(item)} onClose={onClose} size="small">
      <div className="flex flex-col gap-4 p-4 md:gap-6 md:p-6">
        <div className="flex flex-col gap-3 md:gap-4">
          {imageUrl && (
            <div className="overflow-hidden rounded-radius/button border border-borders/default bg-gradient-to-b from-fill/card to-fill/alternative-1 p-spacing/padding/soft-8px">
              <img
                src={imageUrl}
                alt={giftTitle || 'Reward image'}
                className="aspect-[533/342] w-full object-contain"
                loading="lazy"
              />
            </div>
          )}

          <div className="flex flex-col gap-2">
            {giftTitle && (
              <h3 className="mhg-alpha-typography-title-2 text-text/primary">
                {giftTitle}
              </h3>
            )}
            {item.rewardValueText && (
              <div className="mhg-alpha-typography-table-cell-strong w-fit rounded-radius/tooltip px-spacing/padding/soft-8px py-spacing/padding/soft-4px bg-fill/primary-light text-fill/primary-dark">
                {item.rewardValueLabel
                  ? `${item.rewardValueLabel} ${item.rewardValueText}`
                  : item.rewardValueText}
              </div>
            )}
          </div>
        </div>

        {item.products.length > 0 && (
          <div className="grid grid-cols-1 gap-3 xl:grid-cols-2">
            {item.products.map((product) => (
              <ProductGridCard
                {...product}
                key={product.id}
                className="!w-full sm:!w-full xl:!w-full"
              />
            ))}
          </div>
        )}
      </div>
    </AsideModal>
  );
};
